import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";

export const useReportProgramIds = (organizationId, programId) => {
  const [programs, setPrograms] = useState([]);
  const [isLoadingPrograms, setIsLoadingPrograms] = useState(true);
  const [programLoadError, setProgramLoadError] = useState("");

  useEffect(() => {
    if (!organizationId || !programId) {
      return undefined;
    }

    let isMounted = true;
    const programsApiUrl = `/organization/${organizationId}/program/${programId}/descendents?includeSelf=1&flat=1&excludeArchived=true`;

    setIsLoadingPrograms(true);
    setProgramLoadError("");
    setPrograms([]);

    axios.get(programsApiUrl)
      .then((response) => {
        if (isMounted) {
          setPrograms(response.data || []);
        }
      })
      .catch((error) => {
        if (isMounted) {
          setProgramLoadError(error?.message || "Unable to load report programs.");
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingPrograms(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [organizationId, programId]);

  const programIds = useMemo(
    () => programs.map((item) => item.account_holder_id),
    [programs]
  );

  return {
    isLoadingPrograms,
    programLoadError,
    programIds,
  };
};

const ReportProgramsPage = ({
  organization,
  program,
  TableComponent,
  loadingMessage = "Loading report...",
  emptyMessage = "No programs are available for this report.",
  tableProps = {},
}) => {
  const {
    isLoadingPrograms,
    programLoadError,
    programIds,
  } = useReportProgramIds(program?.organization_id ?? organization?.id, program?.id);

  if (isLoadingPrograms) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        {loadingMessage}
      </section>
    );
  }

  if (programLoadError) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        {programLoadError}
      </section>
    );
  }

  if (programIds.length === 0) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        {emptyMessage}
      </section>
    );
  }

  return (
    <section className="manager-report-legacy">
      <TableComponent programs={programIds} {...tableProps} />
    </section>
  );
};

const mapStateToProps = (state) => ({
  organization: state.organization,
  program: state.program,
});

export default connect(mapStateToProps)(ReportProgramsPage);
